module.exports = __webpack_public_path__ + "static/media/banner_midknitetreks.cf58f814.png";